// src/config.ts
// Default to the local landlord-api port (see apps/landlord-api/src/main.ts).
// Override with VITE_API_BASE_URL in apps/landlord-frontend/.env.local.
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:3002";
export const ENV = import.meta.env.VITE_APP_ENV || "development";

// Environment-specific settings
export const isDevelopment = ENV === "development";
export const isProduction = ENV === "production";

/**
 * Phone-support code widget: on/off.
 *
 * Checked in order:
 *   1. `localStorage.lh_phone_support` — per-browser override ("true"/"false"),
 *      so the widget can be enabled for one person in production without a
 *      redeploy.
 *   2. `VITE_PHONE_SUPPORT=true` — the deployed default.
 *
 * To enable for yourself:  localStorage.setItem("lh_phone_support", "true")
 * To revert to the default: localStorage.removeItem("lh_phone_support")
 */
export const PHONE_SUPPORT_OVERRIDE_KEY = "lh_phone_support";

export const isPhoneSupportEnabled = (): boolean => {
  // localStorage throws in some privacy modes; a flag check must never be the
  // thing that breaks a page.
  try {
    const override = window.localStorage.getItem(PHONE_SUPPORT_OVERRIDE_KEY);
    if (override === "true") return true;
    if (override === "false") return false;
  } catch {
    /* fall through to the build-time default */
  }
  return import.meta.env.VITE_PHONE_SUPPORT === "true";
};

/** The number callers dial. Shown next to the code so it's one action. */
export const PHONE_SUPPORT_NUMBER =
  import.meta.env.VITE_SUPPORT_PHONE || "(805) 272-0003";

export default {
  API_BASE_URL,
  ENV,
  isDevelopment,
  isProduction,
};
